import React from "react";
import { useParams } from "react-router-dom";
import { useFetch } from "@/lib/useFetch";
import { usePageMeta, breadcrumbLd, siteUrl } from "@/lib/usePageMeta";
import { useI18n } from "@/contexts/I18nContext";
import { NotFoundState, ErrorState } from "@/components/StateViews";
import { EntityPage, EntitySkeleton } from "@/components/EntityPage";
import { JsonLd } from "@/components/JsonLd";

const Logo = ({ p }) => (
  <div className="flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-[var(--radius)] border border-border bg-card sm:h-32 sm:w-32">
    {p.logo
      ? <img src={p.logo} alt="" width="128" height="128" className="h-full w-full object-cover" />
      : <span aria-hidden="true" className="font-display text-5xl text-primary">{[...(p.name || "?")][0]}</span>}
  </div>
);

export default function PublisherDetail() {
  const { slug } = useParams();
  const { t } = useI18n();
  const { status, data: p, reload } = useFetch(`/publishers/${encodeURIComponent(slug)}`);
  usePageMeta({ title: p ? p.name : status === "notfound" ? t("not_found_title") : undefined,
    description: p?.description, image: p?.logo || undefined, noindex: status === "notfound" || status === "error" });

  if (status === "notfound") return <NotFoundState />;
  if (status === "error") return <ErrorState onRetry={reload} />;
  if (!p) return <EntitySkeleton />;

  return (
    <>
      <JsonLd data={{ "@context": "https://schema.org", "@type": "Organization", name: p.name,
        ...(p.logo ? { logo: p.logo } : {}), url: `${siteUrl()}/publishers/${p.slug}` }} />
      <JsonLd data={breadcrumbLd([{ name: t("site_name"), path: "/" }, { name: t("all_publishers"), path: "/publishers" }, { name: p.name, path: `/publishers/${p.slug}` }])} />
      <EntityPage
        mark={<Logo p={p} />} title={p.name} titleTestId="publisher-name"
        rating={p.avg_rating} reviewCount={p.review_count}
        text={p.description} adPlacement="person-after-bio"
        books={p.books} booksTitle={t("published_books")}
        targetType="publisher" target={p}
      />
    </>
  );
}
